import type { StepFooterCta } from '@/components/work-orders/WorkOrderStepFooter'
import type { WorkOrder } from '@/domain/work-order.types'
import { DesignFilesSection, type DesignHandOver, InProgressStep } from './InProgressStep'
import { PlaceholderStep } from './PlaceholderStep'
import { IN_PROGRESS_STATUS, INTERNAL_REVIEW_STATUS } from './stage-turn'

/** A step without a source-material screen: In progress's own, or the placeholder, under the submitted design on Internal review. */
export function UnbuiltStep({
	workOrder: wo,
	handOver,
	stage,
	moves,
}: {
	workOrder: WorkOrder
	handOver: DesignHandOver
	stage: string
	moves: readonly StepFooterCta[]
}) {
	if (wo.status === IN_PROGRESS_STATUS) return <InProgressStep workOrder={wo} handOver={handOver} />
	return (
		<>
			{wo.status === INTERNAL_REVIEW_STATUS ? <DesignFilesSection workOrder={wo} /> : null}
			<PlaceholderStep stage={stage} moves={moves} />
		</>
	)
}
